import React, { useState } from "react";
import { useEffect } from 'react';
import apiService from "../../service/apiService";
import { MenuItem, Select, InputLabel, FormControl, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import {
    Box,
    Button,
    TextField,
    Typography,
    Grid,
    Paper,
    Container,
    Autocomplete,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const Addcuttingdetails = () => {
    const [cropCuttingDate, setCropCuttingDate] = useState(null);

    const navigate = useNavigate();
    const [seasonList, setSeasonList] = useState([]);
    const [yearList, setYearList] = useState([]);
    const [cropTypeList, setCropTypeList] = useState([]);
    const [farmersList, setFarmersList] = useState([]);
    const [seedClasses, setSeedClasses] = useState([]);
    const [seedClassList, setSeedClassList] = useState([]);
    const [seedList, setSeedList] = useState([]);
    const [varietyList, setVarietyList] = useState([]);
    const [openDelete, setOpenDelete] = useState(false);
    const [updatedBy, setUpdatedBy] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    const [rows, setRows] = useState([]);
    const [casteList, setCasteList] = useState([]);

    useEffect(() => {


        const fetchFarmerData = async () => {
            try {
                const response = await apiService.get("/farmers/get-all");
                setFarmersList(response.data);
            } catch (error) {
                console.error("Error fetching farmer data:", error);
            }
        };
        const fetchSeasonData = async () => {
            try {
                const response = await apiService.get('/seasons/get-all');
                setSeasonList(response.data);
            } catch (error) {
                console.error('Error fetching season data:', error);
            }
        };
        const fetchYearData = async () => {
            try {
                const response = await apiService.get('/years/get-all');
                setYearList(response.data);
            } catch (error) {
                console.error('Error fetching year data:', error);
            }
        };

        const fetchCropTypeData = async () => {
            try {
                const response = await apiService.get("/croptypes/get-all-croptypes");
                setCropTypeList(response.data);
            } catch (error) {
                console.error("Error fetching crop type data:", error);
            }
        };

        const fetchSeedData = async () => {
            try {
                const response = await apiService.get('/seeds/get-all');
                const cleanedData = response.data.map((seed) => ({
                    ...seed,
                    seedName: seed.seedName.trim(),
                }));
                setSeedList(cleanedData);
            } catch (error) {
                console.error('Error fetching seed data:', error);
            }
        };


        const fetchVarietyData = async () => {
            try {
                const response = await apiService.get('/seed-varieties/get-all');
                const cleanedData = response.data.map((variety) => ({
                    ...variety,
                    varietyName: variety.varietyName?.trim(),
                }));
                setVarietyList(cleanedData);
            } catch (error) {
                console.error('Error fetching variety data:', error);
            }
        };
        fetchVarietyData();

        fetchSeedData();
        fetchCropTypeData();
        fetchSeasonData();
        fetchYearData();
        fetchFarmerData();

    }, []);
    const [formData, setFormData] = useState({
        farmerId: "",
        seasonId: "",
        // yearId: "",
        cropCuttingDate: "",
        cropTypeId: "",
        seedId: "",
        seedVarietyId: "",
        cropTypeId: "",
        yield5x5: "",
        yieldPerHectare: "",
        remarks: "",

    });
    const isFormValid = () => {
        return (
            formData.farmerId &&
            formData.seasonId &&
            formData.cropCuttingDate &&
            formData.cropTypeId &&
            formData.seedId &&
            formData.seedVarietyId &&
            formData.yield5x5 &&
            formData.yieldPerHectare
        );
    };

    const handleCancel = () => {
        navigate(-1);
    };
    // const handleChange = (e) => {
    //     setFormData({
    //         ...formData,
    //         [e.target.name]: e.target.value,
    //     });
    // };



    const handleSubmit = async () => {
        try {
            const formattedDate = new Date(formData.cropCuttingDate).toISOString().split('T')[0];

            const payload = [
                {
                    farmerId: formData.farmerId,
                    cropCutting: {
                        seasonId: formData.seasonId,
                        // yearId: formData.yearId,
                        cropCuttingDate: formattedDate,
                        seedId: formData.seedId,
                        seedVarietyId: formData.seedVarietyId,
                        cropTypeId: formData.cropTypeId,
                        yield5x5: parseFloat(formData.yield5x5),
                        yieldPerHectare: parseFloat(formData.yieldPerHectare),
                        remarks: formData.remarks,
                    },
                },
            ];

            const response = await apiService.post(
                '/crop-cutting/create',
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                alert('Data saved successfully!');
                navigate(-1);
            } else {
                alert('Something went wrong! Please try again.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('An error occurred while saving data. Please check your inputs and try again.');
        }
    };




    const handleChange = (event) => {
        const { name, value } = event.target;

        // Check if the input is for yieldPerHectare and perform multiplication for yield5x5
        if (name === "yield5x5") {


            setFormData({
                ...formData,
                [event.target.name]: event.target.value,

                yieldPerHectare: value ? (parseFloat(value) * 4).toFixed(2) : "",
                yield5x5: value // Multiply by 4 and update yield5x5
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };


    return (
        <Paper
        elevation={4}
        sx={{
            padding: 4,
            borderRadius: 0,
            height: "92vh",
            overflowY: "auto",
        }}
    >
        <Typography
            variant="h3"
            gutterBottom
            align="center"
            sx={{
                color: "#1976d2",
                fontWeight: "bold",
            }}
        >
            Add crop cutting details
        </Typography>
    
        <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <Autocomplete
                        options={farmersList}
                        getOptionLabel={(option) => option.farmerName}
                        onChange={(event, value) => {
                            setFormData({
                                ...formData,
                                farmerId: value ? value.farmerId : "",
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={<>Farmers <span style={{ color: 'red' }}>*</span></>}
                                variant="outlined"
                                placeholder="Search farmers..."
                            />
                        )}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined">
                    <InputLabel>Season <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Select
                        label="Season"
                        name="seasonId"
                        value={formData.seasonId}
                        onChange={handleChange}
                    >
                        {seasonList.map((season) => (
                            <MenuItem key={season.seasonId} value={season.seasonId}>
                                {season.seasonName}
                            </MenuItem>
                        ))} 
                    </Select>
                </FormControl>
            </Grid>
    
            <Grid item xs={12} sm={6}>
    <TextField
        fullWidth
        label={<>Crop Cutting Date <span style={{ color: 'red' }}>*</span></>}
        type="date"
        value={formData.cropCuttingDate || ""}
        onChange={(e) =>
            setFormData({ ...formData, cropCuttingDate: e.target.value })
        }
        onFocus={(e) => e.target.showPicker()} 
        InputLabelProps={{ shrink: true }}
    />
</Grid>

            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <Autocomplete
                        options={seedList}
                        getOptionLabel={(option) => option.seedName}
                        onChange={(event, value) => {
                            setFormData({
                                ...formData,
                                seedId: value ? value.seedId : "",
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={<>Seed Name <span style={{ color: 'red' }}>*</span> </>}
                                variant="outlined"
                                placeholder="Search seed..."
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option.seedId === value.seedId}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined">
                    <InputLabel>Seed Variety <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Select
                        label="Seed Variety"
                        name="seedVarietyId"
                        value={formData.seedVarietyId}
                        onChange={handleChange}
                    >
                        {varietyList.map((variety) => (
                            <MenuItem key={variety.seedVarietyId} value={variety.seedVarietyId}>
                                {variety.varietyName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
    
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined">
                    <InputLabel>Crop Type <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Select
                        label="Crop Type"
                        name="cropTypeId"
                        value={formData.cropTypeId}
                        onChange={handleChange}
                    >
                        {cropTypeList.map((cropType) => (
                            <MenuItem key={cropType.cropTypeId} value={cropType.cropTypeId}>
                                {cropType.cropType}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
    
            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label={<>Yield5x5 <span style={{ color: 'red' }}>*</span> </>}
                    name="yield5x5"
                    value={formData.yield5x5}
                    onChange={handleChange}
                    variant="outlined"
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label={<>YieldPerHectare <span style={{ color: 'red' }}>*</span> </>}
                    name="yieldPerHectare"
                    value={formData.yieldPerHectare}
                    onChange={handleChange}
                    variant="outlined"
                    disabled
                />
            </Grid>
    
            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="remarks"
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleChange}
                    variant="outlined"
                />
            </Grid>
    
            {/* Action Buttons */}
            <Grid item xs={12}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: 2,
                        mt: 3
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            paddingX: 3,
                            paddingY: 0.5,
                            height: "40px",
                            borderRadius: "20px",
                            backgroundColor: "#1976d2",
                            "&:hover": {
                                backgroundColor: "#115293",
                                boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)",
                            },
                            transition: "all 0.3s ease-in-out",
                        }}
                        onClick={handleSubmit}
                        disabled={!isFormValid()}

                        // disabled={!Object.values(formData).every(value => value !== "" && value !== null)}
                    >
                        Save
                    </Button>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>
                </Box>
            </Grid>
        </Grid>
    </Paper>
    
    
    );
};
export default Addcuttingdetails;

